import Model, { valueWithArray } from 'ducker-model';

const property = {
  advertisementConfig: valueWithArray(Object), // 广告配置
  announcementConfig: valueWithArray(Object), // 公告配置
  etfBuyConfig: Object, // ETF购买配置
  indexConfigCode: valueWithArray(String), // 指数配置code
};

const replacedKeyFromPropertyName = {
  advertisementConfig: { // 广告配置
    property: 'Modules',
    computed: (value) => {
      if (value?.length) {
        const index = value.findIndex((item) => item?.ModuleCode === 'FundDetailMiddleAd');
        if (index > -1) {
          const data = value[index] || {};
          const CustomArray = data?.CustomArray || [];
          const result = [];
          CustomArray.forEach((item) => {
            result.push({
              type: 'advertisement',
              content: item?.Title,
              tag: item?.TipText,
              tagColor: '#52a2ff',
              link: item?.Link,
              date: '',
              excludeCodes: item?.ExcludeCodes || [],
              includeCodes: item?.IncludeCodes || [],
              fundType: item?.FundType || [],
            });
          });
          return result;
        }
      }
      return [];
    },
  },
  announcementConfig: { // 公告配置
    property: 'Modules',
    computed: (value) => {
      if (value?.length) {
        const index = value.findIndex((item) => item?.ModuleCode === 'FundDetailNotice');
        if (index > -1) {
          const data = value[index] || {};
          const CustomArray = data?.CustomArray || [];
          const result = [];
          CustomArray.forEach((item) => {
            result.push({
              content: item?.Title,
              mode: parseInt(item?.Mode, 10), // 2 没有关闭图标 自动消失 3 有关闭图标 不会自动消失 0 没有关闭图标 不会自动消失
              hotKey: typeof item?.HotKey === 'string' ? item?.HotKey.split(',') : [],
              url: item?.Link?.LinkTo,
              linkType: item?.Link?.LinkType,
              excludeCodes: item?.ExcludeCodes ? item?.ExcludeCodes?.split(',') : [],
              includeCodes: item?.IncludeCodes ? item?.IncludeCodes?.split(',') : [],
              fundType: item?.FundType || '',
            });
          });
          return result;
        }
      }
      return [];
    },
  },
  etfBuyConfig: { // ETF购买配置
    property: ['empty', 'Modules'], // empty兼容ducker-model输出object必须输入也为object的问题
    computed: ([empty = {}, value]) => {
      console.log(empty);
      if (value?.length) {
        const index = value.findIndex((item) => item?.ModuleCode === 'FundDetailSecurity');
        if (index > -1) {
          const data = value[index] || {};
          const CustomArray = data?.CustomArray || [];
          const itemIndex = CustomArray?.findIndex((ele) => ele?.SecurityType === '1');
          const item = CustomArray?.[itemIndex] || {};
          return {
            title: item?.Title,
            url: item?.SkipUrl,
          };
        }
      }
      return {};
    },
  },
  indexConfigCode: { // 指数配置code
    property: 'Modules',
    computed: (value) => {
      if (value?.length) {
        const index = value.findIndex((item) => item?.ModuleCode === 'FundDetailSignal');
        if (index > -1) {
          const data = value[index] || {};
          const CustomArray = data?.CustomArray || [];
          const codes = [];
          CustomArray.forEach((item) => {
            codes.push(item?.FundCode);
          });
          return codes;
        }
      }
      return [];
    },
  },
};

export default new Model(property, replacedKeyFromPropertyName);
